export const drinkFamilies = [
  { value: 'kopi', label: 'Kopi' },
  { value: 'teh', label: 'Teh' },
  { value: 'cham', label: 'Cham' },
  { value: 'milo', label: 'Milo' },
  { value: 'barley', label: 'Barley' },
  { value: 'bandung', label: 'Bandung' },
  { value: 'lemon-tea', label: 'Lemon Tea' },
  { value: 'lime-juice', label: 'Lime Juice' },
  { value: '100-plus', label: '100 Plus' },
  { value: 'coke', label: 'Coke' },
  { value: 'sprite', label: 'Sprite' },
  { value: 'water', label: 'Water' },
  { value: 'chrysanthemum', label: 'Chrysanthemum' }
];

export const modifierOptions = {
  milkOrBlack: [
    { value: 'default', label: 'Default (Condensed Milk)' },
    { value: 'o', label: 'O (Black)' },
    { value: 'c', label: 'C (Evaporated Milk)' }
  ],
  sweetness: [
    { value: 'default', label: 'Default' },
    { value: 'kosong', label: 'Kosong (No Sugar)' },
    { value: 'siew-dai', label: 'Siew Dai (Less Sugar)' },
    { value: 'gah-dai', label: 'Gah Dai (Extra Sugar)' }
  ],
  strength: [
    { value: 'default', label: 'Default' },
    { value: 'gao', label: 'Gao (Strong)' },
    { value: 'po', label: 'Po (Weak)' },
    { value: 'di-lo', label: 'Di Lo (Extra Strong)' }
  ],
  temperature: [
    { value: 'hot', label: 'Hot' },
    { value: 'iced', label: 'Iced (Peng)' }
  ]
};